<template>
<edit />
</template>

<script>
import Edit from "./orgEdit";
export default {
    name:"",
    components:{Edit},
    data() {
        return {

        }
    },
    created() {

    },
    mounted() {

    }
}
</script>
